// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"f834ff3c","147":"48198676","362":"06cc9c67","574":"6c85020d","807":"31fc95c2","818":"405e1afe","899":"a97cddf7","900":"815301c4","952":"0bbce52e","996":"5860403d"}[chunkId] + ".chunk.js";
};